// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { Button, Input, NumberInput } from "@revvsales/components";
import {
  updateDataForStripePaymentSection,
  updateDataForTemplateStripePaymentSection,
  getStripePaymentOnSave,
} from "../../../actions/DocumentActions";
import { DOCUMENTS, EVENTS } from "../../../constants";
import QuotationActions from "../../../actions/QuotationActions";
import StripeSettings from "../../SettingsWrapper/IntegrationsSettings/StripeSettings";
import { AmplitudeUtils } from "../../../utils";

// Components Imports
import { ReactSelect } from "../../../commonComponents";
import {
  CURRENCY_SYMBOL,
  CURRENCY_ALL_DETAILS,
} from "../../../constants/common";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;
const {
  setSectionDataForActivePaymentButtonInRightToolPane,
} = QuotationActions;
const { amplitudeLogEvent } = AmplitudeUtils;

class StripePaymentList extends Component {
  constructor(props) {
    super(props);
    const {
      payNowLabel,
      amount,
      currency,
    } = this.props.sectionDataForStripePayment.data;

    this.state = {
      payNowLabel,
      amount,
      currencyData: currency,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.sectionDataForStripePayment.id !==
      this.props.sectionDataForStripePayment.id
    ) {
      this._updateAmount();
    }
  }

  _updateAmount = () => {
    const {
      payNowLabel,
      amount,
      currency,
    } = this.props.sectionDataForStripePayment.data;
    this.setState({
      payNowLabel,
      amount,
      currencyData: currency,
    });
  };

  _handleValue = (e, name) => {
    if (name === "payLabel") {
      this.setState({
        payNowLabel: e.target.value,
      });
    } else if (name === "amount") {
      this.setState({
        amount: e,
      });
    } else if (name === "currency") {
      this.setState({
        currencyData: e,
      });
    }
  };

  _stopClickEventPropagation = event => {
    event.nativeEvent.stopImmediatePropagation();
  };

  _handlesave = () => {
    const sectionDataForStripePayment = JSON.parse(
      JSON.stringify(this.props.sectionDataForStripePayment),
    );

    const { amount, payNowLabel, currencyData } = this.state;
    const { id } = this.props.sectionDataForStripePayment;

    const usableAmount = (Math.round(amount * 100) / 100).toFixed(2);

    sectionDataForStripePayment.data.editMode = true;
    sectionDataForStripePayment.data.amount = parseFloat(usableAmount);
    sectionDataForStripePayment.data.currency = currencyData;
    sectionDataForStripePayment.data.payNowLabel = payNowLabel;
    sectionDataForStripePayment.data.editClick = false;
    sectionDataForStripePayment.data.stripeUserId = this.props.stripePaymentDetails.stripe_user_id;

    if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      this.props.updateDataForTemplateStripePaymentSection(
        sectionDataForStripePayment,
      );
    } else {
      this.props.updateDataForStripePaymentSection(sectionDataForStripePayment);
    }
    this.props.setSectionDataForActivePaymentButtonInRightToolPane(
      sectionDataForStripePayment,
    );

    // Sending all the payment details and getting data
    const stripeData = {
      doc_id: this.props.document.id,
      currency: currencyData.value.toLowerCase(),
      amount: parseFloat(usableAmount),
      payment_detail: id,
      stripe_user_id: this.props.stripePaymentDetails.stripe_user_id,
    };

    this.props.getStripePaymentOnSave(stripeData);

    amplitudeLogEvent(EVENTS.EVENT_NAMES.STRIPE_BLOCK_SAVED, {
      paymentData: stripeData,
    });
  };

  _handleEdit = () => {
    const sectionDataForStripePayment = JSON.parse(
      JSON.stringify(this.props.sectionDataForStripePayment),
    );

    sectionDataForStripePayment.data.editMode = false;
    sectionDataForStripePayment.data.editClick = true;
    if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      this.props.updateDataForTemplateStripePaymentSection(
        sectionDataForStripePayment,
      );
    } else {
      this.props.updateDataForStripePaymentSection(sectionDataForStripePayment);
    }
    this.props.setSectionDataForActivePaymentButtonInRightToolPane(
      sectionDataForStripePayment,
    );
  };

  _handleCancel = () => {
    const sectionDataForStripePayment = JSON.parse(
      JSON.stringify(this.props.sectionDataForStripePayment),
    );

    sectionDataForStripePayment.data.editMode = true;
    if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      this.props.updateDataForTemplateStripePaymentSection(
        sectionDataForStripePayment,
      );
    } else {
      this.props.updateDataForStripePaymentSection(sectionDataForStripePayment);
    }
    this.props.setSectionDataForActivePaymentButtonInRightToolPane(
      sectionDataForStripePayment,
    );
  };

  render() {
    const { stripePaymentDetails } = this.props;
    let focusValue = null;

    // Getting all the data for currency
    const selectOptions = Object.keys(CURRENCY_ALL_DETAILS).map(a => ({
      value: a,
      label: `${CURRENCY_SYMBOL[a]} - ${CURRENCY_ALL_DETAILS[a].name} (${a})`,
    }));

    // consirion for payment button
    if (
      !this.props.stripePaymentDetails ||
      (this.props.stripePaymentDetails &&
        !this.props.stripePaymentDetails.is_active)
    ) {
      focusValue = false;
    } else {
      focusValue = true;
    }

    return (
      <Fragment>
        <div
          className="stripe-payment-pane-wrapper fadeinright animated"
          onClick={this._stopClickEventPropagation}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <div className="notes-header cover-page">
            <div
              className="right-pane-title"
              role="button"
              tabIndex={0}
              onClick={this.props.hideEditPane}
              onKeyDown={() => {}}>
              <div>Payment button configuration</div>
              <div className="pane-close-icon">
                <i>
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </i>
              </div>
            </div>
          </div>

          <div className="stripe-payment-body-wrapper">
            <div className="content-scroll">
              {this.props.mode === DOCUMENT_MODE.TEMPLATE ? (
                <span className="addproduct-info margin-bottom">
                  <div className="pane-text">
                    Payment button can be configured within the document created
                    from this template
                  </div>
                </span>
              ) : null}
              <span className="addproduct-info margin-bottom">
                {!stripePaymentDetails ||
                (stripePaymentDetails && !stripePaymentDetails.is_active) ? (
                  <div className="pane-text">
                    <div className="top-text">
                      You need a Stripe account to use the payment button.
                    </div>
                    <div className="middle-text">
                      Enable one-click payments for your recipients from this
                      button when you share documents.
                    </div>
                    <div>
                      Securely integrate Revv with your Stripe account for free
                      in 3 easy steps
                    </div>
                    <ol className="list-divs">
                      <li>Click Connect with Stripe below</li>
                      <li>On the Stripe page sign into your Stripe account</li>
                      <li>Authenticate your account to connect with Revv</li>
                    </ol>
                    <StripeSettings pane="true" />
                    <div className="bottom-text">
                      All payments will be managed in and by Stripe. You will
                      not incur any charges from Revv.
                    </div>
                  </div>
                ) : (
                  <div className="pane-text">
                    Revv is now connected with your Stripe account and you have
                    added this payment button. Anyone you share this document
                    with, can click this button and pay the configured amount.
                  </div>
                )}
              </span>

              {this.props.mode !== DOCUMENT_MODE.TEMPLATE ? (
                <Fragment>
                  {!this.props.sectionDataForStripePayment.data.editMode ? (
                    <div
                      className={
                        !this.props.stripePaymentDetails ||
                        (this.props.stripePaymentDetails &&
                          !this.props.stripePaymentDetails.is_active)
                          ? "payment-content-wrapper-disabled"
                          : "payment-content-wrapper"
                      }>
                      <div>
                        <div className="extra-space">
                          <div className="button-label">Button label</div>
                          <Input
                            data-test="stripe-payment-list-label"
                            type="text"
                            value={this.state.payNowLabel}
                            onChange={e => this._handleValue(e, "payLabel")}
                          />
                        </div>
                      </div>
                      <div
                        data-test="stripe-payment-list-curr-label"
                        className="extra-space">
                        <div className="button-label">Choose currecy</div>
                        <ReactSelect
                          data-test="stripe-payment-select-currency"
                          options={selectOptions}
                          onChange={value =>
                            this._handleValue(value, "currency")
                          }
                          value={this.state.currencyData.label}
                          valueKey="value"
                          labelKey="label"
                        />
                      </div>
                      <div className="extra-space">
                        <div className="button-label">Amount</div>
                        <NumberInput
                          data-test="stripe-payment-list-amount"
                          type="number"
                          inpCurrencySymbol={
                            CURRENCY_SYMBOL[this.state.currencyData.value]
                          }
                          isCurrency="true"
                          isFloat="true"
                          value={this.state.amount}
                          onChange={e => this._handleValue(e, "amount")}
                          required
                          placeHolder="0.00"
                          autoFocus={focusValue}
                        />
                      </div>
                      <div className="extra-space">
                        <div className="btn-align">
                          <span>
                            <Button
                              data-test="stripe-payment-list-save-btn"
                              onClick={this._handlesave}
                              className="revv-btn save-btn-large">
                              Save
                            </Button>
                          </span>
                          {this.props.sectionDataForStripePayment.data
                            .editClick ? (
                            <span>
                              <Button
                                data-test="stripe-payment-list-cancel-btn"
                                onClick={this._handleCancel}
                                className="btn btn-transparent">
                                Cancel
                              </Button>
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={
                        !this.props.stripePaymentDetails ||
                        (this.props.stripePaymentDetails &&
                          !this.props.stripePaymentDetails.is_active)
                          ? "payment-content-wrapper-disabled"
                          : "payment-content-wrapper"
                      }>
                      <div className="extra-space">
                        <div className="button-label">
                          Payment to be received
                        </div>
                        <div className="edit-box">
                          <div className="inner-margin">
                            <div className="limit-text">
                              <strong>
                                {
                                  this.props.sectionDataForStripePayment.data
                                    .payNowLabel
                                }
                              </strong>
                              <br />
                              {`${
                                CURRENCY_SYMBOL[
                                  this.props.sectionDataForStripePayment.data
                                    .currency.value
                                ]
                              }${(
                                Math.round(
                                  this.props.sectionDataForStripePayment.data
                                    .amount * 100,
                                ) / 100
                              ).toFixed(2)} (${
                                this.props.sectionDataForStripePayment.data
                                  .currency.value
                              })`}
                            </div>
                            <div>
                              <Button
                                data-test="stripe-payment-list-edit-btn"
                                onClick={this._handleEdit}
                                className="revv-btn-secondary-sm">
                                Edit
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { sectionDataForStripePayment } = state.ToolPaneStore;
  const { document, stripePaymentDetails } = state.DocumentStore;

  return {
    sectionDataForStripePayment,
    document,
    stripePaymentDetails,
  };
};

const mapDispatchToProps = {
  updateDataForStripePaymentSection,
  updateDataForTemplateStripePaymentSection,
  setSectionDataForActivePaymentButtonInRightToolPane,
  getStripePaymentOnSave,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StripePaymentList);



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/StripePaymentListPane/index.js